import { Box } from '@mui/material'
import {
  StyledFilterContainer,
  StyledTableHeader,
  StyledTableHeaderCell,
  StyledTableHeaderFilterCell,
  StyledTableHeaderRow,
  StyledTableRow,
} from './Table.ui'
import { TableHeaderType } from './types'
import { TableFilter } from './TableFilter'
import { TableSortTitle } from './TableSortTitle/TableSortTitle'
import {
  TFiltersState,
  TFilterStateFn,
  TSortValue,
  TSortState,
} from './TableFilter/types'
import { TableColumn } from '../../types'

type TableHeaderProps = {
  columns: TableColumn[]
  hasExpendableRow?: boolean
  headerType?: TableHeaderType
  sortState: TSortState
  setSortState: (sortState: TSortState) => void
  filterState: TFiltersState
  handleFilterState: TFilterStateFn
  handleSortState: (columnId: string, sort: TSortValue) => void
  handleApplyGlobalFilters?: () => void
}

export const TableHeader = ({
  filterState,
  sortState,
  handleFilterState,
  handleSortState,
  columns,
  headerType,
  handleApplyGlobalFilters,
}: TableHeaderProps) => {
  const isColumnRowActive = columns?.some(
    ({ filterParams }) => !!filterParams?.filterVariant
  )

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter' && handleApplyGlobalFilters) {
      handleApplyGlobalFilters()
    }
  }
  return (
    <StyledTableHeader headerType={headerType} onKeyDown={handleKeyDown}>
      <StyledTableHeaderRow>
        {columns.map((column) => (
          <StyledTableHeaderCell
            key={column?.id}
            align={column.align}
            sx={{
              minWidth: column?.minWidth,
              width: column?.minWidth | 150,
              maxWidth: column?.minWidth,
              backgroundColor: (theme) => theme.palette.background.paper,
              zIndex: 2,
              ...(column.isStickyLeft && {
                position: 'sticky',
                left: 0,
                zIndex: 3,
              }),
              ...(column.isStickyRight && {
                position: 'sticky',
                right: 0,
                zIndex: 3,
              }),
            }}
          >
            <Box sx={{ width: '100%', height: '100%' }}>
              <TableSortTitle
                sortable={column.sortable}
                label={column?.label}
                sort={sortState[column?.id]}
                columnId={column?.id}
                handleSortState={handleSortState}
              />
            </Box>
          </StyledTableHeaderCell>
        ))}
      </StyledTableHeaderRow>
      <StyledTableHeaderRow>
        {isColumnRowActive &&
          columns?.map((column) => {
            const value = filterState?.[column?.id]?.value
            const hasValue = Array.isArray(value)
              ? !!value[0] && !!value[1]
              : !!value

            return (
              <StyledTableHeaderFilterCell
                key={column?.id}
                align={column.align}
                sx={{
                  minWidth: column?.minWidth,
                  width: column?.minWidth,
                  maxWidth: column?.minWidth,
                  zIndex: 2,
                  ...(column.isStickyLeft && {
                    position: 'sticky',
                    left: 0,
                    zIndex: 3,
                    backgroundColor: 'background.paper',
                  }),
                  ...(column.isStickyRight && {
                    position: 'sticky',
                    right: 0,
                    zIndex: 3,
                    backgroundColor: 'background.paper',
                  }),
                }}
              >
                <Box sx={{ width: '100%', height: '100%', pb: '10px' }}>
                  <StyledFilterContainer
                    className="styled-filter-container"
                    hasValue={hasValue}
                  >
                    {!!column?.filterParams ? (
                      <TableFilter
                        value={filterState?.[column?.id]?.value}
                        filterType={filterState?.[column?.id]?.filterType}
                        filterParams={column.filterParams}
                        columnId={column?.id}
                        handleFilterState={handleFilterState}
                        handleApplyGlobalFilters={handleApplyGlobalFilters}
                      />
                    ) : null}
                  </StyledFilterContainer>
                </Box>
              </StyledTableHeaderFilterCell>
            )
          })}
      </StyledTableHeaderRow>
    </StyledTableHeader>
  )
}
